<template>
  <b-card class="application-card border-0" body-class="px-1">
    <!-- title and location -->
    <div class="mt-0" v-if="application.job">
      <b>{{ application.job.title }}</b>
    </div>

    <!-- project title in tiny view -->
    <div v-if="application.job.project">
      <p class="m-0 p-0 text-muted">Project: {{ application.job.project.title }}</p>
    </div>

    <!-- dates -->
    <div
      v-if="application.job.project && application.job.project.startDate && application.job.project.endDate"
      class="d-flex justify-content-between align-items-center my-3"
    >
      <span><span class="text-muted">Start</span> <b>{{ formatDate(application.job.project.startDate, 'DD.MM.YYYY') }}</b></span>
      <font-awesome-icon icon="long-arrow-alt-right" />
      <span><span class="text-muted">End</span> <b>{{ formatDate(application.job.project.endDate, 'DD.MM.YYYY') }}</b></span>
    </div>

    <!-- job button in tiny mode -->
    <div v-if="application.job.status === 'ACTIVE' && !application.job.project" class="mt-2">
      <div
        v-if="status(application.status)"
        class="float-left py-2 px-3"
        :style="{
          fontSize: '0.8rem',
          border: '1px solid #fff',
          borderRadius: '3px',
          color: status(application.status).color,
          borderColor: status(application.status).color,
        }"
      >
        <b>{{ status(application.status).name }}</b>
      </div>
      <b-link
        class="float-right py-2"
        variant="outline-primary"
        :to="!canEmployeeApply ? { name: 'InternalJobShow', params: { jobID: application.job.id } } : { name: 'CampaignJobShow', params: { jobID: application.job.id } } "
      >
        View Job
      </b-link>
    </div>

    <!-- project button in tiny mode -->
    <div v-if="application.job.status === 'ACTIVE' && application.job.project" class="mt-2">
      <div
        v-if="status(application.status)"
        class="float-left py-2 px-3"
        :style="{
          fontSize: '0.8rem',
          border: '1px solid #fff',
          borderRadius: '3px',
          color: status(application.status).color,
          borderColor: status(application.status).color,
        }"
      >
        <b>{{ status(application.status) ? status(application.status).name : '' }}</b>
      </div>
      <b-link
        class="float-right py-2"
        variant="primary"
        :to="{ name: 'ProjectShow', params: { projectID: application.job.project.id }, query: { jobID: application.job.id } }"
      >
        View Project
      </b-link>
    </div>
  </b-card>

</template>

<script>
import formatDate from 'date-fns/format';
import { mapPreferences } from '@/mixins/root';

const statuses = {
  'CREATED': {
    name: 'PENDING',
    color: '#6c757d',
  },
  'HIRED': {
    name: 'SUCCESSFUL',
    color: '#28a745',
  },
  'INTERVIEW': {
    name: 'INTERVIEW',
    color: '#fd7e14',
  },
  'REJECTED': {
    name: 'Unsuccessful',
    color: '#6f6f6f',
  },
};

export default {
  props: {
    application: {
      type: Object,
    },
  },
  computed: {
    ...mapPreferences([ 'canEmployeeApply' ]),
  },
  methods: {
    truncute(str, limit) {
      return str.length > limit ? `${str.substr(0, limit)}...` : str;
    },
    status(status) {
      return status ? statuses[status] : null;
    },
    formatDate,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/profile/ApplicationCard.vue